import { render } from "./MentorshipPage.vue?vue&type=template&id=1fb6d287"
import script from "./MentorshipPage.vue?vue&type=script&lang=js"
export * from "./MentorshipPage.vue?vue&type=script&lang=js"

import exportComponent from "/root/mentoringplatform-acm/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__